import { createSlice } from '@reduxjs/toolkit';
import { addAuthToLocalStorage, getAuthFromLocalStorage, removeAuthFromLocalStorage } from '../../utils/storage';
import { TAuthUser } from 'types/authType';

interface TAuthState {
  isAuthenticated: boolean;
  user: TAuthUser | null;
  token: string | null;
}

const auth = getAuthFromLocalStorage();

const user = auth.user;
const token = auth.token;

const initialState: TAuthState = {
  isAuthenticated: !!token,
  user,
  token,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLogin(state, action) {
      if (action.payload.user && action.payload.token) {
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
        addAuthToLocalStorage(action.payload);
      }
    },
    setLogout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      removeAuthFromLocalStorage();
    },
  },
});

export const { setLogin, setLogout } = authSlice.actions;
export default authSlice.reducer;
